import React from "react";
import TalktoUs from "../../components/ContactUsForm/TalktoUs";
import { Box } from "@mui/material";
import ContactusBgLanding from "./ContactusBgLanding";
import ContactusMap from "./ContactusMap";
import { Toaster } from "react-hot-toast";
import ContactCard from "./ContactCard";
import { Helmet } from "react-helmet";

const Contactus = () => {
  return (
    <>
      <Helmet>
        <title>Inteliphyle | Contact Us</title>
        <meta
          name="description"
          content="Inteliphyle provides advisory solutions that combine machine intelligence, human expertise, and artificial intelligence to deliver smarter decision-making for businesses worldwide."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <ContactusBgLanding />
        <ContactusMap />
        {/* <ContactCard /> */}
        <TalktoUs Header="Get in Touch" />
        <Toaster
          position="bottom-right"
          toastOptions={{
            duration: 3000,
            style: {
              background: "#FFFFFF", // White background
              color: "#1F2128", // Dark text for contrast
              borderRadius: "8px",
              padding: "12px 16px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              border: "1px solid #FF6A00", // Subtle orange border for theme consistency
            },
            success: {
              iconTheme: {
                primary: "#4ADE80", // Green success icon
                secondary: "#FFFFFF",
              },
            },
            error: {
              iconTheme: {
                primary: "#EF4444", // Red error icon
                secondary: "#FFFFFF",
              },
            },
          }}
        />
        ;
      </Box>
    </>
  );
};

export default Contactus;
